<h1>Lot on Plan</h1>
<div class="preamble instructions">
  <p>What is the lot on plan number of the area to be cleared?</p>
</div>

<form [formGroup]="form" method="post" class="form">
  <ol class="questions">
    <li class="group">
      <ol class="questions compact">
        <li> <label for="lot"> <span class="label">Lot</span> <abbr title="(required)" class="required">*</abbr>
      </label>
      <input type="text" formControlName="lot" id="lot" placeholder="Lot" required="required" />
    </li>
    <li> <label for="plan"> <span class="label">Plan (for example, SP112233)</span> <abbr title="(required)"
  class="required">*</abbr>
</label>
<input type="text" formControlName="plan" placeholder="Plan" id="plan" value="" required="required" />
</li>
</ol>
</li>
<li> <strong> <input class="qg-btn btn-primary" type="submit" (click)="verify()" value="Verify" />
</strong> </li>
</ol>
@if (!!lotPlanData.lot && !!lotPlanData.plan && !lotPlanData.lotOnPlanValid) {
  <div class="alert alert-warning mt-4"
    role="alert">
    <h2><i class="fa fa-exclamation-triangle"></i>Lot on Plan is invalid</h2>
    <p>
      The Lot on Plan cannot be found. Please check that you have entered the
      correct lot on plan numbers.
    </p>
  </div>
}
@if (lotPlanData.lotOnPlanValid  && !lotPlanData.tenureIsValid) {
  <div class="alert alert-warning mt-4" role="alert">
    <h2><i class="fa fa-exclamation-triangle"></i>Tenure is invalid</h2>
    <p>This lot on plan has a "{{ lotPlanData.tenure }}" tenure. Only freehold and leasehold are valid
      for this form.
    </p>
    <p>Contact your regional office or consider alternative approval options.</p>
  </div>
}
@if (showNoCategoriesWarning() || showNoValidCategoriesWarning()) {
  <div class="alert alert-warning mt-4"
    role="alert">
    <h2><i class="fa fa-exclamation-triangle"></i>{{ showNoValidCategoriesWarning() ?
  'Invalid vegetation categories' : 'No categories found' }}</h2>
  <p>{{ showNoValidCategoriesWarning() ? 'The accepted development codes apply only to Category B, Category C ' +
    'and Category R areas and these were not found on the specified lot on plan.' :
    'No categories were found on the specified Lot on Plan.' }}
  </p>
  <p>Contact your regional office or consider alternative approval options.</p>
  <ul>
    <li><strong>Area:</strong> {{ lotPlanData.area }} ha</li>
    <li><strong>Tenure:</strong> {{ lotPlanData.tenure }}</li>
    <li>
      <strong>Local government areas:</strong>
      <ul>
        @for (lga of lotPlanData.localGovernmentAreas; track lga) {
          <li>
            {{lga}}
          </li>
        }
      </ul>
    </li>
    <li>
      <strong>Categories:</strong>
      <ul>
        @for (category of lotPlanData.categories; track category) {
          <li>
            Category {{ category }}
          </li>
        }
      </ul>
    </li>
    <li>
      <strong>Bioregions:</strong>
      <ul>
        @for (bioregion of lotPlanData.bioregions; track bioregion) {
          <li>
            {{ bioregion }}
          </li>
        }
      </ul>
    </li>
  </ul>
</div>
}
@if (showLotPlanInformation) {
  <div class="alert alert-success" role="alert">
    <h2><i class="fa fa-check-circle"></i>Results</h2>
    <ul>
      <li><strong>Area:</strong> {{ lotPlanData.area }} ha</li>
      <li><strong>Tenure:</strong> {{ lotPlanData.tenure }}</li>
      <li><strong>Koala Habitat Area:</strong> {{ (lotPlanData.containsKoalaHabitatArea ||
    this.lotPlanData.containsLocallyRefinedKoalaHabitatArea) ? 'Yes' : 'No' }}</li>
    <li><strong>Koala Priority Area:</strong> {{ lotPlanData.containsKoalaPriorityArea ? 'Yes' :
  'No' }}</li>
  <li><strong>SEQ regional plan Area:</strong> {{ lotPlanData.containsSeqRegionalPlanArea ?
'Yes' : 'No'}}</li>
<li><strong>Wet Tropics Qld world heritage area:</strong> {{ lotPlanData.containsWetTropicsQldWorldHeritageArea ?
'Yes' : 'No'}}</li>
<li><strong>Coastal/Non-coastal lot:</strong> {{ lotPlanData.isCoastalLotPlanBioregion ?
'Coastal' : 'Non-Coastal'}}</li>
<li>
  <strong>Local government areas:</strong>
  <ul>
    @for (lga of lotPlanData.localGovernmentAreas; track lga) {
      <li>
        {{lga}}
      </li>
    }
  </ul>
</li>
<li>
  <strong>Vegetation categories:</strong>
  <ul>
    @for (category of lotPlanData.categories; track category) {
      <li>
        Category {{category}}
      </li>
    }
  </ul>
</li>
<li>
  <strong>Bioregions:</strong>
  <ul>
    @for (bioregion of lotPlanData.bioregions; track bioregion) {
      <li>
        {{bioregion}}
      </li>
    }
  </ul>
</li>
</ul>
</div>
}
@if (lotPlanData.containsWetTropicsQldWorldHeritageArea) {
  <div class="alert alert-info" role="alert">
    <h3><i class="fa fa-info-circle"></i> This property is located in the Wet Tropics World Heritage Area.</h3><br/>
    Before commencing clearing, it is recommended that you contact the Wet Tropics Management Authority to discuss any clearing, development or other activities on phone (07) 4241 0500, wettropics&#64;wtma.qld.gov.au or visit <a href='http://www.wettropics.gov.au' target="_blank">www.wettropics.gov.au</a>
  </div>
}
@if (lotPlanData.tenureIsValid && (lotPlanData.containsKoalaHabitatArea ||
  lotPlanData.containsKoalaPriorityArea || lotPlanData.containsLocallyRefinedKoalaHabitatArea)) {
  <div class="alert alert-info" role="alert">
    <h2><i class="fa fa-info-circle"></i></h2>
    This property may contain areas regulated under the koala protection framework.
    Before commencing clearing, it is recommended that you contact the Department of the Environment, Tourism, Science and Innovation - Koala Team on: 13 QGOV
    (13 74 68).
  </div>
}
<br />
<div class="footer">
  <ul class="actions">
    <li> <input class="qg-btn btn-global-secondary" type="submit" (click)="previous()" value="Previous" /> </li>
    <li> <em> <input [disabled]="!allowToGoNextScreen" class="qg-btn btn-primary"
    type="submit" (click)="next()" value="Next" /> </em> </li>
  </ul>
  <ul class="actions">
    <li>
      <a href (click)="cancel()">Cancel</a>
    </li>
  </ul>
</div>
</form>
